import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';

export default function AaSequencePreview(props: PreviewProps): JSX.Element {
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-protein',
    noteType: NoteConstants.PROTEIN,

    renderItem: () => null,
  });
  return render();
}
